module.exports = __webpack_public_path__ + "static/media/partners1.338568ea.gif";